module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.56395d5.eot";